import styled from 'styled-components'

const Style = {
	Content: styled.div`
		display: flex;
		flex-direction: column;
		gap: 16px;
		width: 100%;
	`,
}

export default Style
